<template>
  <div>
    <div v-if="loading" class="text-center" style="margin-top: 10em">
      <div class="lds-roller">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-3">
              <!-- <router-link v-bind:to="'/pago/' + id_usuario" class="btn btn-orange rounded-pill">
                <i class="bx bx-chevron-left"></i> Regresar
              </router-link> -->
              <button_back></button_back>
              <br />
            </div>
            <div class="mt-2 mb-3"></div>
            <div class="card">
              <div class="card-header">
                <h4 class="text-orange fw-bold">Anexos</h4>
              </div>
              <div class="card-body">
                <!-- <div class="row">
                  <div class="col-lg-3">
                    <div class="card card-body border shadow">
                      <div class="text-center">
                        <div v-if="anexos.cedula != null" class="mb-4">
                          <a v-bind:href="anexos.cedula.url" target="_blank">
                            <i class="bx bx-file-blank bx-lg"></i>
                          </a>
                          <br />
                          <small> {{ anexos.cedula.fecha_registro }} </small
                          ><br />
                          <router-link
                            v-bind:to="
                              '/cargar_anexo_membresia/' +
                              usuario.id_usuario +
                              '/' +
                              anexos.cedula.id_tipo_anexo
                            "
                            class="btn btn-outline-dark rounded-pill btn-sm mt-3 mb-2"
                          >
                            <i class="bx bx-upload"></i> Modificar archivo
                          </router-link>
                        </div>
                        <div v-else>
                          <div>
                            <i class="bx bx-info-circle bx-lg text-muted"></i>
                            <br />
                            No se ha cargado archivo.
                          </div>
                          <br />
                          <router-link
                            v-bind:to="
                              '/cargar_anexo_membresia/' + id_usuario + '/1'
                            "
                            class="btn btn-outline-dark rounded-pill btn-sm mb-4"
                          >
                            <i class="bx bx-upload"></i> Cargar archivo
                          </router-link>
                        </div>
                        <div>
                          <span class="fw-bold text-orange"
                            >Cédula del cliente</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->
                <hr />
                <h4 class="text-orange fw-bold">Soportes de pago</h4>
                <div class="text-start">
                  <router-link v-bind:to="'/cargar_anexo_membresia/' + id_usuario + '/2'"
                    class="btn btn-orange rounded-pill btn-sm mb-4">
                    <i class="bx bx-plus-circle"></i> Subir nuevo soporte
                  </router-link>
                </div>
                <div v-if="anexos.soportes != null" class="row">
                  <div v-for="(anexo, index_anexo) in anexos.soportes" v-bind:key="index_anexo" class="col-lg-3">
                    <div class="card card-body border shadow">
                      <div class="text-center">
                        <div class="mb-4">
                          <a v-bind:href="anexo.url" target="_blank">
                            <i class="bx bx-file-blank bx-lg"></i>
                          </a>
                          <br />
                          <small> {{ anexo.fecha_registro }} </small>
                        </div>
                        <div>
                          <span class="fw-bold text-orange">Soporte de pago</span>
                          <br />
                          <div v-if="anexo.estado_soporte_pago == 1" class="badge bg-success">
                            Pago aprobado
                          </div>
                          <div v-else class="badge bg-warning">
                            Pago no aprobado
                          </div>
                          <br />
                          <!-- <button
                            @click="
                              (anexo_sel = anexo),
                                $modal.show('modal_estado_soporte')
                            "
                            class="btn btn-outline-dark rounded-pill btn-sm mt-3 mb-2"
                          >
                            <i class="bx bx-check-circle"></i> Cambiar estado
                          </button> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mb-3 text-end">
              <router-link to="/" class="btn btn-orange rounded-pill">
                <i class="bx bx-chevron-left"></i> Finalizar
              </router-link>
              <router-link v-bind:to="'/contrato_membresia/' + id_usuario" class="btn btn-orange rounded-pill">
                Siguiente <i class="bx bx-chevron-right"></i>
              </router-link>
            </div>
          </div>
        </div>
      </transition>
      <modal name="modal_estado_soporte" :adaptive="true" height="350">
        <div class="card border m-4">
          <div class="card-header">
            <h4 class="fw-bold text-orange">Estado de soporte</h4>
          </div>
          <div class="card-body">
            <div v-if="anexo_sel != null">
              <ul>
                <li>
                  Fecha de registro:
                  <strong>{{ anexo_sel.fecha_registro }}</strong>
                </li>
                <li>
                  <a v-bind:href="anexo_sel.url" target="_blank" class="mt-2 fw-bold">
                    Ver archivo
                  </a>
                </li>
              </ul>
              <div class="form-group">
                <label>Estado</label>
                <select v-model="anexo_sel.estado_soporte" class="form-control">
                  <option value="0">No aprobado</option>
                  <option value="1">Aprobado</option>
                </select>
              </div>
              <div class="text-end">
                <button v-on:click="set_estado_soporte" class="btn btn-success rounded-pill">
                  <i class="bx bx-save"></i> Guardar
                </button>
                <button @click="$modal.hide('modal_estado_soporte')" class="btn btn-outline-secondary rounded-pill ms-1">
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { defineAsyncComponent } from 'vue';
export default {
  name: "Anexos",
  metaInfo: {
    title: "Anexos membresía - Reddy Backoffice",
  },
  components: {
    button_back: defineAsyncComponent(() => import('../../components/BackBtn')),
  },
  data() {
    return {
      loading: true,
      loading_upload: false,
      id_usuario: null,
      usuario: [],
      anexos: [],
      nombre: null,
      hay_archivo: false,
      file: null,
      anexo_sel: null,
    };
  },
  props: {
    session: Object,
  },
  created: function () {
    this.id_usuario = this.$route.params.id_usuario;
    this.get_usuario();
  },
  methods: {
    get_usuario: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(this.$base_url + "clientes/cliente/" + this.id_usuario, config, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.usuario = response.data.data;
          this.get_anexos();
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    get_anexos: function () {
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
      };
      axios
        .get(
          this.$base_url +
          "membresias/anexos/" +
          this.usuario.membresia.id_membresia,
          config,
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (!response.data.status) {
            this.$notify({
              type: "error",
              group: "foo",
              title: "Ups!",
              text: response.data.message,
            });
          }
          this.anexos = response.data.data.anexos;
          this.loading = false;
        })
        .catch((error) =>
          this.$notify({
            type: "error",
            group: "foo",
            title: "Ups!",
            text: error,
          })
        )
        .finally();
    },
    on_file_change(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.hay_archivo = false;
        return;
      }
      this.file = files;
      this.hay_archivo = true;
    },
    upload: function () {
      this.hay_archivo = false;
      this.loading = true;
      var formData = new FormData();
      formData.append("files", this.file[0]);
      formData.append("token", this.session.token);
      formData.append("id_membresia", this.usuario.membresia.id_membresia);
      formData.append("nombre", this.nombre);
      const vm = this;
      axios
        .post(this.$base_url + "upload/anexo_membresia", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status) {
            vm.hay_archivo = false;
            vm.$notify({
              group: "foo",
              type: "success",
              title: "Excelente!",
              text: "Se ha subido el anexo.",
            });
            vm.loading_upload = false;
            vm.nombre = null;
            vm.file = null;
            vm.get_anexos();
          } else {
            vm.$notify({
              group: "foo",
              type: "error",
              title: "Ups!",
              text: response.data.message,
            });
            vm.loading = false;
          }
        })
        .catch((error) => {
          vm.$notify({
            group: "foo",
            type: "error",
            title: "Ups",
            text: error,
          });
          console.log(error);
          vm.loading_upload = false;
        });
    },
    set_estado_soporte: function () {
      this.loading = true;
      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      var params = {
        id_usuario: this.usuario.id_cliente,
        id_anexo: this.anexo_sel.id_anexo,
        estado: this.anexo_sel.estado_soporte,
      };
      axios
        .post(this.$base_url + "membresias/set_estado_soporte", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Error",
              text: response.data.message,
            });
            return false;
          }

          vm.get_anexos();
          vm.$modal.hide("modal_estado_soporte");
          vm.loading = false;
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "Important message",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
    },
  },
};
</script>